<template>
  <v-form v-model="valid">
    <h2 v-if ="newProjectFlag"> Create Project</h2>
    <h2 v-else ="newProjectFlag"> Edit Project</h2>
    <v-text-field ref="input" :rules="[rules.required, rules.counter, rules.uniqueName, rules.whiteSpaceBeginEnd]" counter maxlength="225" label="Name" v-model="value.name"  v-on:keyup="validate()" ></v-text-field>
    <v-card>
    <v-textarea v-model="value.text" label="Note" counter maxlength="255"> </v-textarea>
    </v-card>
  </v-form>
</template>

<script>
import _ from "lodash"
export default {
  name: "projectForm",
  props: ["value", "newProjectFlag","projects"],

  data() {
    return {
      valid: true,
      typeInput: "",
      tempProjects: this.projects,
      rules: {
          required: value => !!value || 'Required.',
          counter: value => value.length <= 225 || 'Max 225 characters',
          uniqueName: value => this.checkforExistingName(value) || 'Project name already existing',
          whiteSpaceBeginEnd: value => this.checkForWhiteSpacesBeginEnd(value) || 'No white spaces at begin or end',
          //doubleWhiteSpaces: value => this.checkForDoubleWhiteSpaces(value) || 'No double white spaces'
        }
    }
  },
  watch: {
    value(nv) {
      this.model = nv
    }
  },
  created() {

    this.$nextTick(() => this.$refs.input.focus())
    this.validate()
  },
  methods: {
    validate(){

        this.valid =this.validateRequired(this.value.name)
        && this.checkforExistingName(this.value.name)
        && this.checkForWhiteSpacesBeginEnd(this.value.name)
      //  && this.checkForDoubleWhiteSpaces(this.value.name)
        this.$emit('valid',this.valid)

     },

     checkForWhiteSpacesBeginEnd(input){
       var whiteSpaceIndices = this.getWhiteSpace(input)
       return !(whiteSpaceIndices[0] == 1 || whiteSpaceIndices[whiteSpaceIndices.length-1] == input.length)

     },
     checkForDoubleWhiteSpaces(input){
       var whiteSpaceIndices = this.getWhiteSpace(input)

         for(var i=0; i<whiteSpaceIndices.length-1;i++) {
           if (whiteSpaceIndices[i]+1 === whiteSpaceIndices[i+1]){
             return false

           }
        }
        return true
     },
    getWhiteSpace(s) {
      var indices = [];
        for(var i=0; i<s.length;i++) {
          if (s[i] === " ") indices.push(i+1);
       }
       return indices;
     },


    validateRequired(input){
          return !!input
    },

      checkforExistingName(name){
        let count=0
        for(let i =0; i<this.tempProjects.length;i++){
          if(name == this.tempProjects[i].name)
            count++
        }
        if(count>1)
        return false
        else {
          return true
        }
      }


  },
}
</script>

<style scoped>
h2 {
  font-weight: normal;
  color: #3675cc;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectForm.vue